/**
 * EventsPanel — Care events timeline widget for subject dashboard.
 *
 * DRR-321: Extracted from SubjectDashboardPage for widget registry.
 */

import React from 'react';
import { Skeleton, Alert } from '@mantine/core';
import { IconTimeline } from '@tabler/icons-react';

import {
  JourneyTimeline,
  useSubjectJourneyTimeline,
} from '@ferp/workflow-forms';
import type { WidgetProps } from '@ferp/core';

export function EventsPanel({ subjectActorId }: WidgetProps) {
  const result = useSubjectJourneyTimeline(subjectActorId, 5);

  if (result.loading && result.events.length === 0) {
    return <Skeleton height={100} />;
  }

  if (result.events.length === 0) {
    return (
      <Alert icon={<IconTimeline size={16} />} color="blue" variant="light">
        No care events recorded yet.
      </Alert>
    );
  }

  return (
    <JourneyTimeline
      events={result.events}
      activeEvents={result.activeEvents}
      historicalEvents={result.historicalEvents}
      totalEvents={result.totalEvents}
      activeEventCount={result.activeEventCount}
      loading={result.loading}
    />
  );
}
